module.exports = __webpack_public_path__ + "img/dataCenter_bg1.d0ee4eb1.png";